import { Image } from "@chakra-ui/react"

export const BotDoctor = ({ height = 80, width = 80 }) => {
  return (
    <Image src={require('./botDoctor.png')} width={width} height={height} />
  )
}